import React, {useState, useEffect} from 'react'

import {Link} from '../routes'

import Page from "../components/page";
import Vimeo from '../components/structure/vimeo'
import {H1, H3, H4, P} from "../components/font-style/font-styles";
import {Wrapper, Row, Column} from "../components/structure/page-structure";
import toc from '../data/toc'



const Carousel = props => {
    const [visible, setVisible] = useState([])
    const [position, setPosition] = useState(0)

    useEffect(() => {
        if (props.data[position] && props.data[position+1]) {
            let temp = [props.data[position], props.data[position + 1]]
            setVisible(temp)
        }
        else {
            setVisible(props.data)
        }
    }, [props])
    const clickRight = () => {

        let tempPos = position + 1
        if (tempPos + 2 <= props.data.length) {
            let temp = [props.data[tempPos], props.data[tempPos+1]]
            setPosition(tempPos)
            setVisible(temp)
        }
    }

    const clickLeft = () => {
        let tempPos = position - 1
        if (tempPos >= 0) {
            let temp = [props.data[tempPos], props.data[tempPos+1]]
            setPosition(tempPos)
            setVisible(temp)
        }
    }

    return (
        <Row>
            {props.data.length >=3 && <div onClick={clickLeft}>⬅️</div>}
            {visible.map(item => (
                <Column>
                    {props.type === 'videos'
                        ?
                        <Vimeo
                            video={`${item.url.split('https://vimeo.com/')[1]}`}
                            color={"808080"}
                            showTitle={false}
                            showPortrait={false}
                            showByline={false}

                        />

                        :
                        <img src={item.image ? item.image : 'https://via.placeholder.com/450x350'}/>
                    }
                    <H4>{item.title}</H4>
                    {/*<Link href={`/${props.type}?title=${item.slug}`}><a>Click Here</a></Link>*/}
                    <Link as={`/${props.type}/${item.slug}`} href={`/${props.type}?slug=${item.slug}`}><a>Click Here</a></Link>
                </Column>
            ))}
            {props.data.length >=3 && <div onClick={clickRight}>➡️</div>}
        </Row>
    )
}



const Index = props => {
    const [articles, setArticles] = useState([])
    const [videos, setVideos] = useState([])
    const [blog, setBlog] = useState([])

    useEffect(() => {
        let tempArticles = []
        props.resources.articles.forEach(item => {
            if (item.featured) {
                tempArticles.push(item)
            }
        })
        setArticles(tempArticles)

        let tempVideos = []
        props.resources.videos.forEach(item => {
            if (item.featured) {
                tempVideos.push(item)
            }
        })
        setVideos(tempVideos)

        let tempBlog = []
        props.resources.posts.forEach(item => {
            if (item.featured) {
                tempBlog.push(item)
            }
        })
        setBlog(tempBlog)
    }, [])
	return (
		<Page>
			<p>-</p>
			Image
            <Wrapper>
				<H1>Page Title Goes Here</H1>
				<H3>Featured Articles</H3>
                <Carousel type={'article'} data={articles}/>
                <H3>Featured Videos</H3>
                <Carousel type={'video'} data={videos}/>

                <H3>Featured Posts</H3>
                <Carousel type={'blog'} data={blog}/>

			</Wrapper>
		</Page>
	)
}


export default () => (

    <Index resources={toc}/>

)